module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "lrc-content"
  }, [_c('scroll', {
    ref: "scrolls",
    attrs: {
      "data": _vm.lrc
    }
  }, [_c('ul', {
    staticClass: "lrc-wrapper"
  }, [_vm._l((_vm.lrc), function(value, key, index) {
    return _c('li', {
      key: key,
      class: {
        active: _vm.currentTime === parseInt(key)
      }
    }, [_vm._v(_vm._s(value))])
  }), _vm._v(" "), (!Object.keys(_vm.lrc).length) ? _c('li', [_vm._v("歌词加载中")]) : _vm._e()], 2)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-48bb20f6"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/lrc/lrc.vue
// module id = 203
// module chunks = 1